import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

export const CancelButton = styled(Button)`
  && {
    width: 'auto';
    height: 36px;
    margin-bottom: 16px;
    background-color: #ffffff;
    color: #35373c;
    font-size: 11px;
    font-family: 'IRANYekanXFaNum';
    font-weight: 500;
    line-height: 16px;
    padding: 4px;

    justify-content: space-between;
    text-transform: none;
    text-align: right;
    box-shadow: none;
    border: 1px solid #ededed;

    &:hover {
      background-color: #ededed;
    }
  }
`;
